import React, { useState, useEffect, useRef, useContext } from 'react';
import OwlCarousel from 'react-owl-carousel3';
import Accordion from 'react-bootstrap/Accordion';

import { useParams, useLocation } from 'react-router-dom';
import { Link } from "react-router-dom";
import { useStateWithCallbackLazy } from 'use-state-with-callback';
import InfiniteScroll from 'react-infinite-scroll-component';

import Header from '../layout/Header';
import Footer from '../layout/Footer';
import ProductList from '../view/Component/ProductList';
import TopFilterBar from '../view/Component/TopFilterBar';
import apiPath from "../constants/apiPath";
import Http from "../services/Http";
import toast, { Toaster } from 'react-hot-toast';
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css';

import ImgCross from '../assets/img/close.png';
import ImgSortIc from '../assets/img/sort_ic.png';
import ImgFilterIc from '../assets/img/filter_ic.png';

import noProduct from '../assets/img/noProduct.png';

import LocalizedStrings from "react-localization";
import localization from "../localization";
import Modal from 'react-bootstrap/Modal';
import Imgcross from '../assets/img/cross.png';
import { Button, Form } from 'react-bootstrap';
import { SelectGroup, ValidationForm } from "react-bootstrap4-form-validation";

import { Helmet } from 'react-helmet';
import LoadingOverlay from 'react-loading-overlay-ts';
import ScrollContext from '../ScrollContext';
import Currency from '../view/Component/Currency';
import '../assets/css/collection-desktop.css';

let strings = new LocalizedStrings(localization);
const options = {
    rtl: true,
    margin: 0,
    nav: true,
    dots: false,
    loop: true,
    responsive: {
        0: {
            items: 1,
            margin: 7.5
        },
        420: {
            items: 1
        },
        577: {
            items: 1
        },
        992: {
            items: 1
        }
    }
};

const brandOption = {
    margin: 15,
    nav: true,
    dots: false,
    loop: true,
    responsive: {
        0: {
            items: 1.5,
            margin: 7.5
        },
        577: {
            items: 3
        },
        992: {
            items: 4
        },
        1366: {
            items: 5
        }
    }
}

const flowersOption = {
    margin: 15,
    nav: true,
    dots: false,
    loop: true,
    responsive: {
        0: {
            items: 2.3,
            margin: 7.5
        },
        577: {
            items: 3
        },
        992: {
            items: 5
        },
        1366: {
            items: 6
        }
    }
}

const comboOption = {
    margin: 15,
    nav: true,
    dots: false,
    loop: true,
    responsive: {
        0: {
            items: 1,
            margin: 7.5
        },
        420: {
            items: 2
        },
        577: {
            items: 2
        },
        992: {
            items: 2
        },
        1366: {
            items: 3
        }
    }
}

const DiscountOption = {
    margin: 15,
    nav: true,
    dots: false,
    loop: true,
    responsive: {
        0: {
            items: 1,
            margin: 7.5
        },
        420: {
            items: 2
        },
        577: {
            items: 2
        },
        992: {
            items: 3
        },
        1366: {
            items: 4
        }
    }
}


const Product = (Props) => {

    // Sticky sidebar
    const [isSticky, setIsSticky] = useState(false);
    const [isDesktop, setIsDesktop] = useState(window.innerWidth > 992);
    const [setting, setSetting] = useState([]);

    const headerHeight = 110;
    const handleScroll = () => {
        if (isDesktop) {
            const scrollTop = window.scrollY;
            if (scrollTop > headerHeight) {
                setIsSticky(true);
            } else {
                setIsSticky(false);
            }
        }
    };

    const getSetting = async () => {
		let path = apiPath.setting;
		var data = new FormData();
		let options = {
			method: "GET",
		};
		let result = await Http(path, options);
		if (result.status == 200) {
			if (result.data.status == true) {
				setSetting({ data: result.data.data });
			} else {
				toast.error(result.data.message);
			}
		} else {
			if(result.statusText != null) {
				toast.error(result?.data?.message || result.statusText);
			}
		}
	};

    const handleResize = () => {
        setIsDesktop(window.innerWidth > 992);
    };

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        window.addEventListener("resize", handleResize);
        
        getSetting();

        return () => {
            window.removeEventListener("scroll", handleScroll);
            window.removeEventListener("resize", handleResize);
        };
    }, [isDesktop]);
    // End

    const { isScrolled } = useContext(ScrollContext);
    const location = useLocation();
    const formRef = React.createRef();
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [isActive, setActive] = useState(true)

    const setModalIsOpenToTrue = (item, attributes, variantImage) => {
        const firstAttrValues = attributes[0]?.attribute_values || [];
		const firstAttrValue = firstAttrValues[0];

		setComman(prev => ({
			...prev,
			product_id: item.id,
			attributes: attributes,
            product_variant_image: variantImage,
			product: item,
			attribute_value_id: firstAttrValue?.id || null
		}), () => {
			if (firstAttrValues.length > 1 && firstAttrValue?.id) {
				handleAttributeChange(item.id, firstAttrValue.id);
			}
		});
        setModalIsOpen(true)
    }

    const setModalIsOpenToFalse = () => {
        setModalIsOpen(false)
    }

    const showAddtoCart = async (e, item, attributes, variantImage) => {
        e.preventDefault();
        if (attributes.length > 0) {
            setModalIsOpenToTrue(item, attributes, variantImage);
        } else {
            setComman({ ...comman, product_id: item.id, attribute_value_id: null, product_variant_image: variantImage, product: item });
            addtoCart(item.id, null, variantImage);
        }
    };

    const handleAttributeChange = async (productId, attributeValueId) => {
		try {
			let path = apiPath.ProductAvailability + '/' + productId;
			var data = new FormData();
			data.append('attribute_value_id', attributeValueId);
			let options = {
				method: 'POST',
				data: data
			}
			let result = await Http(path, options);
			if (result.status == 200) {
				if (result.data.status) {
					setComman(prev => ({
						...prev,
						product: {
							...prev.product,
							discount_price: result.data.data.product.discount_price,
							original_price: result.data.data.product.original_price
						}
					}));
				}
				else {
					toast.error(result.data.message);
				}
			}
		} catch (error) {
		  console.error('Error updating price:', error);
		  toast.error('An error occurred while updating price');
		}
	};

    const addtoCart = async (id, type, variantImage) => {
        let path = apiPath.AddtoCart;
        var data = new FormData();
        data.append('product_id', id);
        data.append('qty', 1);
        data.append('is_increment', 1);
        if (type == null && comman.attribute_value_id != null) {
            data.append('product_attribute_values_id', comman.attribute_value_id);
        }
        else if (type == 'form') {
            const attributeValueId = document.querySelector('input[name="attribute_value_id"]:checked');
            if (attributeValueId != null && attributeValueId != "") {
                data.append('product_attribute_values_id', attributeValueId.value);
            }
        }

        if (variantImage) {
            data.append('variant_image_id', variantImage);
        }

        let options = {
            method: 'POST',
            data: data
        }

        let result = await Http(path, options);
        if (result.status == 200) {
            if (result.data.status) {
                toast.success(result.data.message);
            }
            else {
                toast.error(result.data.message);
            }
            setModalIsOpenToFalse();
        }
    }

    const listInnerRef = useRef();
    const shuffleSeedRef = useRef(Math.floor(Math.random() * 2147483647) + 1);
    const [lastList, setLastList] = useState(false);
    const params = useParams();
    const { categorySlug } = params;

    const isBrandAlias = location.pathname.startsWith('/brand/');

    const isCategorySlugRoute =
        categorySlug &&
        !params.type &&
        !isBrandAlias;

    let normalizedType = params.type;
    let normalizedTypeId = params.typeId;

    if (isBrandAlias) {
        normalizedType = 'brand';
        normalizedTypeId = params.slug;
    }
    else if (isCategorySlugRoute) {
        normalizedType = 'category';
        normalizedTypeId = categorySlug;
        
        // Special case
        if (categorySlug == 'new-arrival' || categorySlug == 'bundle-products' || categorySlug == 'nice-collection') {
            normalizedType = categorySlug;
        }
    }

    const [open, setOpen] = React.useState(false);
    const [filters, setFilters] = useState([]);
    const [product, setProduct] = useState([]);
    const [value, setValue] = React.useState([2, 10]);
    // Available price range for the current collection (min = cheapest in-stock product).
    const [priceBounds, setPriceBounds] = useState({ min: 0, max: 0 });
    // The From/To values currently typed into the price filter inputs.
    const [priceInput, setPriceInput] = useState({ from: '', to: '' });
    const [meta, setMeta] = useStateWithCallbackLazy({
        'meta_title': 'Best Perfume in Kuwait | Men, Women, Unisex & Bakhoor | TPS',
        'meta_description': 'Best perfume for men, women, and unisex, including bakhoor and beauty products. Available for delivery in Kuwait from The Perfume Smell',
        'meta_keywords': 'The perfume smell'
    });
    const [comman, setComman] = useStateWithCallbackLazy({
        page: 1,
        last_page: 0,
        showLoad: 'showCl',
        minPrice: 0,
        maxPrice: 0,
        short: '',
        category: [],
        brand: [],
        rating: 0,
        notes: [],
        perfumeTypes: [],
        min_price: null,
        max_price: null,
        is_Wishlist: 0,
        product_id: 0,
        attributes: [],
        attribute_value_id: null,
        product_variant_image: null,
        product: null
    });
    const [currPage, setCurrPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [prevPage, setPrevPage] = useState(0);
    const [userList, setUserList] = useState([]);
    // const [lastList, setLastList] = useState(false);


    const handleOpen = () => {
        setOpen(!open);
    };

    const [currentLang, setCurrentLang] = useState(
        localStorage.getItem("current_lang")
            ? localStorage.getItem("current_lang")
            : "en"
    );
    strings.setLanguage(currentLang);

    const getProduct = async (page) => {
        setActive(true);
        let path = apiPath.product;
        var data = new FormData();
        
        const queryParams = new URLSearchParams(location.search);
        const searchValue = queryParams.get('search');
        if (searchValue) {
            data.append('name', searchValue);
        }
        const accordValue = queryParams.get('accord');
        if (accordValue) {
            data.append('accord_name', accordValue);
        }
        const noteValue = queryParams.get('note');
        if (noteValue) {
            data.append('scent_note', noteValue);
        }

        data.append('page', page);
        data.append('type', normalizedType);
        data.append('typeId', normalizedTypeId);
        if (comman.brand.length > 0) {
            data.append('brand_id', comman.brand);
        }

        if (params.typeId == undefined && params.type != '' && params.type != 'new-arrival' && params.type != 'bundle-products' && params.type != 'nice-collection' && params.type != undefined && comman.category.length <= 0 && comman.brand.length <= 0 && comman.rating <= 0 && comman.maxPrice <= 0 && comman.notes.length <= 0 && comman.perfumeTypes <= 0) {
            data.append('category_slug', params.type);
            data.set('type', 'category');
            data.set('typeId', params.type);
        }

        if (params.type == 'brand' && params.typeId != '' && comman.category.length <= 0 && comman.brand.length <= 0 && comman.rating <= 0 && comman.maxPrice <= 0 && comman.notes.length <= 0 && comman.perfumeTypes <= 0) {
            data.append('brand_id', params.typeId);
        }
        if (params.type == 'category' && params.typeId != '' && comman.category.length <= 0 && comman.brand.length <= 0 && comman.rating <= 0 && comman.maxPrice <= 0 && comman.notes.length <= 0 && comman.perfumeTypes <= 0) {
            data.append('category_id', params.typeId);
        }
        // Sub-category scope is NOT applied by the backend's type-block (it only
        // handles category/brand), so it must ride along on EVERY request — even
        // when facets are selected — otherwise picking a filter drops the sub scope
        // and the page shows results from the whole site instead of this sub-category.
        if (params.type == 'sub' && params.typeId != '') {
            data.append('sub_category_id', params.typeId);
        }

        if (comman.category.length > 0) {

            data.append('category_id', comman.category);
        }

        if (comman.perfumeTypes.length > 0) {

            data.append('perfumeTypes', comman.perfumeTypes);
        }
        if (comman.notes.length > 0) {
            data.append('notes_id', comman.notes);
        }
        if (comman.rating > 0) {
            data.append('rating', comman.rating);
        }
        if (params.type == "price") {
            data.append('price', params.typeId);
        }
        if (params.type == "discount") {
            data.append('discount', params.typeId);
        }
        // Price range filter (From / To). Backend applies whereBetween(min_price, max_price).
        if (comman.min_price != null && comman.max_price != null) {
            data.append('min_price', comman.min_price);
            data.append('max_price', comman.max_price);
        }
        if (comman.short) {
            data.append('order_by', comman.short);
        }
        else {
            data.append('shuffle_seed', shuffleSeedRef.current);
        }

        let options = {
            method: 'POST',
            //				headers: { 'language': this.state.language },
            data: data
        }

        let result = await Http(path, options);
        if (result.status === 200) {
            if (result.data) {
                let resultJson = result.data.result;

                if (page == 1) {
                    setProduct({
                        data: result.data.data.data,
                    })
                    setComman({ ...comman, last_page: result.data.data.last_page, page: page });
                }
                else {
                    setProduct({
                        data: product.data.concat(result.data.data.data)
                    })
                }

                if (result.data.data.meta_title) {
                    setMeta({
                        'meta_title': result.data.data.meta_title,
                        'meta_description': result.data.data.meta_description,
                        'meta_keywords': result.data.data.meta_keywords
                    });
                }

                if (page === result.data.data.last_page) {
                    setComman({ ...comman, showLoad: 'hideCl', page: page });
                    setHasMore(false)
                }


            } else {
                toast.error(result.data.message);
            }
        } else {
            if (result.statusText != null) {
                toast.error(result?.data?.message || result.statusText);
            }
        }
        setActive(false);
    }

    /**
     * Append the current collection scope (sub-category / category / brand / type)
     * so filter facets and price bounds match the products on this page.
     */
    const appendScope = (data) => {
        if (normalizedType === 'sub' && normalizedTypeId) {
            data.append('sub_category_id', normalizedTypeId);
        } else if (normalizedType === 'category' && normalizedTypeId) {
            data.append('category_id', normalizedTypeId);
        } else if (normalizedType === 'brand' && normalizedTypeId) {
            data.append('brand_id', normalizedTypeId);
        }
        if (normalizedType) {
            data.append('type', normalizedType);
        }
    };

    const getFilterData = async () => {
        let data = new FormData();
        appendScope(data);
        let result = await Http(apiPath.getFilterData, { method: 'POST', data });

        if (result.status === 200) {
            if (result.data.status) {
                const fd = result.data.data;
                setFilters({ data: fd });
                if (fd.min_price != null && fd.max_price != null) {
                    // Scope-aware backend already returned the collection price range.
                    const min = Math.floor(parseFloat(fd.min_price));
                    const max = Math.ceil(parseFloat(fd.max_price));
                    setPriceBounds({ min, max });
                    setPriceInput({ from: String(min), to: String(max) });
                } else {
                    // Older backend: derive bounds from the product endpoint.
                    getPriceBounds();
                }
            } else {
                toast.error(result.data.message);
            }
        } else {
            if (result.statusText != null) {
                toast.error(result?.data?.message || result.statusText);
            }
        }
    }

    /**
     * Fallback price range (used when the filter API doesn't return min/max):
     * scoped to the current collection via the product endpoint.
     */
    const getPriceBounds = async () => {
        try {
            let data = new FormData();
            data.append('page', 1);
            appendScope(data);
            let result = await Http(apiPath.product, { method: 'POST', data });
            if (result.status !== 200 || !result.data || !result.data.data) return;

            const payload = result.data.data;
            const max = Math.ceil(parseFloat(payload.productMaxPrice)) || 0;
            let min;
            if (payload.productMinPrice != null) {
                // Accurate global minimum provided by the backend.
                min = Math.floor(parseFloat(payload.productMinPrice));
            } else {
                // Fallback for backends without productMinPrice: cheapest listed product.
                let cheapData = new FormData();
                cheapData.append('page', 1);
                cheapData.append('limit', 1);
                cheapData.append('order_by', 'LOWPRICE');
                appendScope(cheapData);
                const cheapRes = await Http(apiPath.product, { method: 'POST', data: cheapData });
                const cheapest = cheapRes?.data?.data?.data?.[0];
                min = cheapest ? Math.floor(parseFloat(cheapest.original_price)) : 0;
            }
            setPriceBounds({ min, max });
            setPriceInput({ from: String(min), to: String(max) });
        } catch (error) {
            console.error('Price bounds error:', error);
        }
    }

    const resetAndFetch = () => {
        try {
            setProduct([]);
            setHasMore(true);
            setCurrPage(1);
            setComman(prev => ({
                ...prev,
                page: 1,
                showLoad: 'showCl'
            }));
        } catch (error) {
            console.error('Reset error:', error);
        }
    };

    const handleOnFilter = (e, type, value) => {
        // Immutable, functional updates only — the fetch effects (watching
        // comman.category/brand/rating/notes/perfumeTypes/short + currPage)
        // re-request the product list whenever these change.
        const toggle = (arr) => {
            const list = Array.isArray(arr) ? arr : [];
            return list.map(String).includes(String(value))
                ? list.filter(v => String(v) !== String(value))
                : [...list, value];
        };

        if (type === 'short') {
            setComman(prev => ({ ...prev, short: e.target.value, page: 1 }));
        } else {
            setComman(prev => {
                const next = { ...prev, page: 1 };
                if (type === 'category') next.category = toggle(prev.category);
                else if (type === 'brand') next.brand = toggle(prev.brand);
                else if (type === 'notes') next.notes = toggle(prev.notes);
                else if (type === 'perfumeTypes') next.perfumeTypes = toggle(prev.perfumeTypes);
                else if (type === 'rating') next.rating = (prev.rating === value ? 0 : value);
                return next;
            });
        }

        // Restart pagination from page 1 for the new filter set.
        setProduct([]);
        setHasMore(true);
        setCurrPage(1);
    }

    /**
     * Desktop top-filter-bar helpers.
     * Remove a single value from an array facet (category/brand/notes/perfumeTypes).
     */
    const removeArrayFilter = (type, id) => {
        setComman(prev => ({
            ...prev,
            [type]: (prev[type] || []).filter(v => String(v) !== String(id))
        }));
        resetAndFetch();
    };

    /** Reset a scalar facet (rating -> 0, short -> ''). */
    const clearScalarFilter = (type, empty) => {
        setComman(prev => ({ ...prev, [type]: empty }));
        resetAndFetch();
    };

    /** Apply the From/To price range. Empty inputs fall back to the collection bounds. */
    const applyPriceRange = () => {
        let from = priceInput.from === '' ? priceBounds.min : Math.max(priceBounds.min, parseFloat(priceInput.from));
        let to = priceInput.to === '' ? priceBounds.max : Math.min(priceBounds.max, parseFloat(priceInput.to));
        if (isNaN(from)) from = priceBounds.min;
        if (isNaN(to)) to = priceBounds.max;
        if (from > to) { const t = from; from = to; to = t; }
        setPriceInput({ from: String(from), to: String(to) });
        setComman(prev => ({ ...prev, min_price: from, max_price: to }));
        resetAndFetch();
    };

    /** Remove the active price range filter. */
    const clearPriceFilter = () => {
        setPriceInput({ from: String(priceBounds.min), to: String(priceBounds.max) });
        setComman(prev => ({ ...prev, min_price: null, max_price: null }));
        resetAndFetch();
    };

    /** Clear every active filter at once. */
    const clearAllFilters = () => {
        setComman(prev => ({
            ...prev,
            category: [],
            brand: [],
            rating: 0,
            notes: [],
            perfumeTypes: [],
            short: '',
            min_price: null,
            max_price: null
        }));
        setValue([2, 10]);
        setPriceInput({ from: String(priceBounds.min), to: String(priceBounds.max) });
        resetAndFetch();
    };

    /** Look up a facet option's display name by id. */
    const facetName = (list, id) => {
        const found = (list || []).find(o => String(o.id) === String(id));
        return found ? found.name : id;
    };

    /** From/To price range control (shared by the sidebar and the top filter bar). */
    const renderPriceFilter = () => (
        <div className="tfb_price_filter">
            <div className="tfb_price_avail">
                {strings.lowest || 'Lowest'}<Currency data={priceBounds.min} />
                <span className="tfb_price_sep">·</span>
                {strings.highest || 'Highest'}<Currency data={priceBounds.max} />
            </div>
            <div className="tfb_price_inputs">
                <div className="tfb_price_field">
                    <span>{strings.from || 'From'}</span>
                    <input
                        type="number"
                        min={priceBounds.min}
                        max={priceBounds.max}
                        value={priceInput.from}
                        placeholder={String(priceBounds.min)}
                        onChange={(e) => setPriceInput((p) => ({ ...p, from: e.target.value }))}
                    />
                </div>
                <span className="tfb_price_dash">–</span>
                <div className="tfb_price_field">
                    <span>{strings.to || 'To'}</span>
                    <input
                        type="number"
                        min={priceBounds.min}
                        max={priceBounds.max}
                        value={priceInput.to}
                        placeholder={String(priceBounds.max)}
                        onChange={(e) => setPriceInput((p) => ({ ...p, to: e.target.value }))}
                    />
                </div>
            </div>
            <button type="button" className="tfb_price_apply" onClick={applyPriceRange}>
                {strings.apply || 'Apply'}
            </button>
        </div>
    );

    const handleFavourite = async (e, id, type, index) => {

        let path = apiPath.AddRemoveWishlist;
        var data = new FormData()
        data.append('product_id', id);
        data.append('type', type);
        let options = {
            method: 'POST',
            data: data
        }

        let result = await Http(path, options);
        if (result.status === 200) {
            if (result.data.status) {
                var is_wish = product.data[index].is_wishlist;
                var is_wish_val = 0;

                if (type == 'add') {
                    setProduct({ ...product, [product.data[index].is_wishlist]: 0 });
                    setComman({ ...comman, is_Wishlist: 0 })
                    // getProduct(1)
                }
                else {
                    setProduct({ ...product, [product.data[index].is_wishlist]: 1 });
                    // getProduct(1)
                }

                toast.success(result.data.message);
            } else {
                toast.error(result.data.message);
            }
        } else {
            if (result.statusText != null) {
                toast.error(result?.data?.message || result.statusText);
            }
        }


    }

    const onScroll = async (e) => {
        // console.log((window.pageYOffset + document.documentElement.clientHeight).toFixed(0), document.documentElement.scrollHeight);
        console.log(comman.showLoad, "comman.showLoad")
        if (parseInt((window.pageYOffset + document.documentElement.clientHeight).toFixed(0)) === (document.documentElement.scrollHeight)) {
            if (comman.showLoad != "hideCl") {
                setCurrPage(prevPageNumber => prevPageNumber + 1)
            }


        }
    };

    const onNext = () => {
        if (hasMore) {
            setCurrPage(prevPageNumber => prevPageNumber + 1)
        }
    }

    // Refetch scoped filter facets + price bounds whenever the collection changes.
    useEffect(() => {
        getFilterData();
    }, [normalizedType, normalizedTypeId])

    /**
     * Fetch product when page or filters change
     */
    useEffect(() => {
        try {
            getProduct(currPage);
        } catch (error) {
            console.error('Fetch product error:', error);
        }
    }, [
        currPage,
        normalizedType,
        normalizedTypeId,
        comman.category,
        comman.brand,
        comman.rating,
        comman.notes,
        comman.perfumeTypes,
        comman.min_price,
        comman.max_price
    ]);


    useEffect(() => {
        localStorage.setItem("type", params.type)
        getProduct(1);
    }, [value, comman.short]);

    const loadMore = (data) => {
        var page = comman.page
        page = page + 1;
        setComman({ ...comman, page: page });
        getProduct(page);
    }

    const priceChange = (newValue) => {
        setValue(newValue);
    }

    useEffect(() => {
        resetAndFetch();
    }, [location.pathname, location.search]);


    const addClass = (e, type) => {
        if (type == "short") {
            document.getElementsByTagName('body')[0].setAttribute("class", 'open_sort');
        }
        else {
            document.getElementsByTagName('body')[0].setAttribute("class", 'open_filter');
        }
    }


    const removeClass = (f, type) => {
        if (type == "short") {
            document.getElementsByTagName('body')[0].setAttribute("class", '');
        }
        else {
            document.getElementsByTagName('body')[0].setAttribute("class", '');
        }

        // alert(type)


    }

    return (
        <>
        <LoadingOverlay active={isActive} spinner>
            <Helmet>
                <title>{meta.meta_title || "Best Perfume in Kuwait | Men, Women, Unisex & Bakhoor | TPS"}</title>
                <meta name="description" content={meta.meta_description || "Best perfume for men, women, and unisex, including bakhoor and beauty products. Available for delivery in Kuwait from The Perfume Smell"} />
                <meta name="keywords" content={meta.meta_keywords || "The perfumesmell"} />
                <meta property="og:title" content={meta.meta_title || "Best Perfume in Kuwait | Men, Women, Unisex & Bakhoor | TPS"} />
                <meta property="og:description" content={meta.meta_description || "Best perfume for men, women, and unisex, including bakhoor and beauty products. Available for delivery in Kuwait from The Perfume Smell"} />
                <link rel="canonical" href={`https://www.theperfumesmell.com${location.pathname}`} />
            </Helmet>
            <Header new={params.type} data={true} isScrolled={isScrolled} />
            <main>
                <section className="cart-page mobile-button">
                <div className="container">
                    <div className="cart_row">
                        <div className="cart_left">
                            <div className="cart_title try_sample_title">
                            {setting.data && setting.data.special_menu_enable ? (
                                <Link to="/special-sale" className="nav-link special-sale-btn">
                                    <span className="header_badge">
                                        {setting.data.special_menu_text}
                                    </span>
                                </Link>
                            ) : (
                                <Link to="/try-samples" className="nav-link">
                                    <span className="try_samples_badge">
                                        {strings.trySamples}
                                    </span>
                                </Link>
                            )}
                            </div>
                        </div>
                    </div>
                </div>
                </section>
                {filters.data ?
                    <section className="space-cls banner-sec">
                        <div className="container">
                            {filters.data.limited_product.length > 0 &&
                                <OwlCarousel className="owl-carousel  owl-theme" {...options}  >
                                    {filters.data.limited_product.map((option, index) =>
                                        <div className="item">
                                            <div className="banner-img">
                                                <a
                                                    href={
                                                        option.type === 'brand'
                                                            ? `/brand/${option.banner_for_id}`
                                                            : `/product/${option.type !== 'product' ? option.type : 'product-detail'}/${option.banner_for_id}`
                                                    }
                                                >
                                                    <picture>
                                                        <source media="(min-width:575.98px)" srcSet={option.file} />
                                                        <img src={option.file} alt={option.file} />
                                                    </picture>
                                                </a>
                                            </div>
                                        </div>
                                    )}
                                    {/* {filters.data.limited_product.map((option, index) => { */}
                                    {/* <div className="item">
                              <div className="banner-img">
                                 <picture>
                                    <source media="(min-width:575.98px)" srcSet={option.file} />
                                    <img src={option.file} alt="" />
                                 </picture>
                              </div>
                           </div> */}

                                    {/* <div className="item">
                        <div className="banner-img">
                           <picture>
                              <source media="(min-width:575.98px)" srcSet={ImgBannerPrd} />
                              <img src={ImgMBannerPrd} alt="" />
                           </picture>
                        </div>
                     </div>
                     <div className="item">
                        <div className="banner-img">
                           <picture>
                              <source media="(min-width:575.98px)" srcSet={ImgBannerPrd} />
                              <img src={ImgMBannerPrd} alt="" />
                           </picture>
                        </div>
                     </div> */}
                                    {/* })} */}
                                </OwlCarousel>
                            }

                        </div>
                    </section> : null}
                <section className="space-cls product_listing tfb_only">
                    <div className="container">
                        <div className="product_wrap row">
                            <div className={`product_right_s ${isScrolled ? 'is_scrolled' : ''}`}>
                                {filters.data && (
                                    <TopFilterBar
                                        filters={filters.data}
                                        comman={comman}
                                        setComman={setComman}
                                        strings={strings}
                                        priceBounds={priceBounds}
                                        priceInput={priceInput}
                                        setPriceInput={setPriceInput}
                                        onChange={resetAndFetch}
                                        hideBrand={normalizedType === 'brand'}
                                        hideCategory={normalizedType === 'category'}
                                    />
                                )}
                                <div className="relative-loading" >
                                    {product.data ? product.data.length > 0 ?
                                        <InfiniteScroll
                                            // scrollableTarget="ProductList"
                                            dataLength={product?.data?.length || 0}
                                            // scrollThreshold={0.80}
                                            next={onNext}
                                            hasMore={hasMore}
                                            loader={<div class="loader"></div>}
                                        >
                                            <ProductList showAddtoCart={showAddtoCart} data={product.data} handleFavourite={handleFavourite} />
                                            {/* </InfiniteScroll> */}

                                            {/* <ProductList data={product.data} handleFavourite={handleFavourite} /> */}
                                        </InfiniteScroll>
                                        :
                                        <section className="space-cls no_image review_noImg">
                                            <div className="container">
                                                <div className="cart_row">
                                                    <div className='col-md-12'>
                                                        <h3>
                                                            <center>
                                                                <img src={noProduct} alt="Out of stock" />
                                                            </center>
                                                        </h3>
                                                    </div>
                                                </div>
                                            </div>
                                        </section> : ''}
                                </div>

                                {/* <div className={"load-more d-flex justify-content-center mt-2 " + comman.showLoad}>

                           <button type="button" className="btn btn_primary" onClick={loadMore}>Load More</button>
                        </div> */}

                                {/*<div className="sale-sec">
                     <OwlCarousel className="owl-carousel  owl-theme" {...flowersOption}  > 
                
                          <div className="item">
                            <div className="sale-prd">
                              <a href="#">
                                <img src={ImgmSale1} alt=""/>
                              </a>
                            </div>
                          </div>
                          <div className="item">
                            <div className="sale-prd">
                              <a href="#">
                                <img src={ImgmSale2} alt=""/>
                              </a>
                            </div>
                          </div>
                          <div className="item">
                            <div className="sale-prd">
                              <a href="#">
                                <img src={ImgmSale3} alt=""/>
                              </a>
                            </div>
                          </div>
                          <div className="item">
                            <div className="sale-prd">
                              <a href="#">
                                <img src={ImgmSale4} alt=""/>
                              </a>
                            </div>
                          </div>
                          <div className="item">
                            <div className="sale-prd">
                              <a href="#">
                                <img src={ImgmSale1} alt=""/>
                              </a>
                            </div>
                          </div>
                          <div className="item">
                            <div className="sale-prd">
                              <a href="#">
                                <img src={ImgmSale2} alt=""/>
                              </a>
                            </div>
                          </div>
                          <div className="item">
                            <div className="sale-prd">
                              <a href="#">
                                <img src={ImgmSale3} alt=""/>
                              </a>
                            </div>
                          </div>
                          <div className="item">
                            <div className="sale-prd">
                              <a href="#">
                                <img src={ImgmSale4} alt=""/>
                              </a>
                            </div>
                          </div>
                        
                        </OwlCarousel>
    </div>*/}
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
        </LoadingOverlay>
        {modalIsOpen ? <>
				<Modal id="selectionModal" show={true} animation={true} size="lg" backdrop="static" keyboard={false} centered>
					<Modal.Header className="modal-header-custom">
						{/* <h5 className="modal-title">{strings.pickItemSize}</h5> */}
						<button
						type="button"
						className="btn-close"
						aria-label="Close"
						onClick={setModalIsOpenToFalse}
						>
						<img src={Imgcross} alt="Close" />
						</button>
					</Modal.Header>
					<Modal.Body className="modal-body-custom">
						<ValidationForm ref={formRef}>
						<div className="product-details">
							<img src={comman.product.image} alt={comman.product.name} className="product-image" />
							<div className="product-info">
								<h6 className="product-name">{comman.product.name}</h6>
								{/* Size Options */}
								<Form.Group className="form-group prd-size-group" controlId="form-group">
									<div className="prd_size_label">
									{comman.attributes[0]?.attribute_values &&
										comman.attributes[0].attribute_values.map((option, i) => (
										<label className="custom_radio_b" key={option.id}>
											<input
											type="radio"
											name="attribute_value_id"
											value={option.id}
											defaultChecked={i === 0}
                                            onChange={(e) => handleAttributeChange(comman.product.id, option.id)}
											/>
											<span className="checkmark">{option.value}</span>
										</label>
										))}
									</div>
								</Form.Group>
							</div>
							<div className="product-price">
								<Currency data={comman.product.discount_price != 0 ? comman.product.discount_price : comman.product.original_price} />
							</div>
						</div>

						{/* Submit Button */}
						<div className="login-btn">
							<Button
							onClick={(e) => addtoCart(comman.product_id, 'form', comman.product_variant_image)}
							type="button"
							className="btn btn-primary w-100"
							>
							{strings.pickThisSize}
							</Button>
						</div>
						</ValidationForm>
					</Modal.Body>
				</Modal></> : ""}
        </>
    )
}

export default Product;
